import type { UnknownAction } from "@reduxjs/toolkit"

import {
	ADD_TO_KBAR_LISTS,
	HIDE_KBAR,
	KBAR_REDUCER_ACTION_TYPES,
	type KbarAction,
	type KbarList,
	type KbarLists,
	SET_KBAR_ANIMATION,
	SET_KBAR_LIST,
	SET_KBAR_LOADING,
	SET_KBAR_LOCATION,
	SET_KBAR_PLACEHOLDER,
	SHOW_KBAR,
} from "./actions"

type KbarState = {
	// Kbar panel animation
	animation: "in" | "out" | "transition" | ""
	// Kbar visibility
	visible: boolean
	// Current displaying list, null while a new one is loading
	list: KbarList | null
	// Kbar list cache (key-list pairs)
	lists: KbarLists
	// Kbar location (an array of list keys)
	location: string[]
	// Kbar loading status
	loading: boolean
	// Kbar input placeholder
	placeholder: string
}

const KbarInitialState: KbarState = {
	animation: "",
	visible: false,
	list: [],
	lists: {
		home: [],
	},
	location: ["home"],
	loading: false,
	placeholder: "Type your command or search...",
}

const isKbarAction = (action: UnknownAction): action is KbarAction =>
	KBAR_REDUCER_ACTION_TYPES.includes(action.type)

const kbarReducer = (
	state = KbarInitialState,
	action: UnknownAction
): KbarState => {
	if (!isKbarAction(action)) return state

	switch (action.type) {
		case SET_KBAR_LIST:
			return {
				...state,
				list: action.payload.list,
			}
		case ADD_TO_KBAR_LISTS:
			return {
				...state,
				lists: {
					...state.lists,
					[action.payload.key]: action.payload.list,
				},
			}
		case SHOW_KBAR:
			return {
				...state,
				visible: true,
			}
		case HIDE_KBAR:
			return {
				...state,
				visible: false,
			}
		case SET_KBAR_ANIMATION:
			return {
				...state,
				animation: action.payload.state,
			}
		case SET_KBAR_LOCATION:
			return {
				...state,
				location: action.payload.location,
			}
		case SET_KBAR_LOADING:
			return {
				...state,
				list: action.payload.status ? null : state.list,
				loading: action.payload.status,
			}
		case SET_KBAR_PLACEHOLDER:
			return {
				...state,
				placeholder: action.payload.placeholder,
			}
		default:
			return state
	}
}

export default kbarReducer
